import {IBannerData} from './IBannerData';

export class BannerDataJson implements IBannerData {
    height: string;
    width: string;
    clickUrl: string;
    targetUrl: string;

    static INTERNAL_IMG_URL_KEY = "img_file";
    static INTERNAL_PIXEL_URL_KEY = "click_url";
    static INTERNAL_URL_KEY = "url";
    static INTERNAL_URL_1_KEY = "url1";
    static INTERNAL_HEIGHT_KEY = "height";
    static INTERNAL_WIDTH_KEY = "width";
    static INTERNAL_TITLE_KEY = "title";

    constructor(json: Record<string, unknown>) {
        this.height = BannerDataJson.getStringNotNull(json, BannerDataJson.INTERNAL_HEIGHT_KEY);
        this.width = BannerDataJson.getStringNotNull(json, BannerDataJson.INTERNAL_WIDTH_KEY);
        this.clickUrl = BannerDataJson.getStringNotNull(json, BannerDataJson.INTERNAL_PIXEL_URL_KEY);
        this.targetUrl = BannerDataJson.getTargetUrl(json);
    }

    static getStringNotNull(json: Record<string, unknown>, field: string) {
        return String(json[field] || '');
    }

    static getTargetUrl(json: Record<string, unknown>) {
        let url = BannerDataJson.getStringNotNull(json, BannerDataJson.INTERNAL_URL_KEY)
                    || BannerDataJson.getStringNotNull(json, BannerDataJson.INTERNAL_URL_1_KEY);
        return url.replace(/^https?:\/\/[^/]+/, '');
    }
}
